import { render, staticRenderFns } from "./BidDing.vue?vue&type=template&id=1f42d0e5&scoped=true"
import script from "./BidDing.vue?vue&type=script&lang=js"
export * from "./BidDing.vue?vue&type=script&lang=js"
import style0 from "./BidDing.vue?vue&type=style&index=0&id=1f42d0e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42d0e5",
  null
  
)

export default component.exports